import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { ActionService } from 'src/app/shared/services/action/action.service';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActionAgeingActionableIssueCountComponent } from '../action-ageing-actionable-issue-count/action-ageing-actionable-issue-count.component';
import { ActionAgeingActionableIssueSummaryComponent } from '../action-ageing-actionable-issue-summary/action-ageing-actionable-issue-summary.component';
import { ActionAgeingActionableIssueTrendChartComponent } from '../action-ageing-actionable-issue-trend-chart/action-ageing-actionable-issue-trend-chart.component';
import { ActionAgeingActionableIssueBarChartComponent } from '../action-ageing-actionable-issue-bar-chart/action-ageing-actionable-issue-bar-chart.component';
@Component({
    selector: 'app-project-action-ageing-home',
    templateUrl: './project-action-ageing-home.component.html',
    styleUrls: ['./project-action-ageing-home.component.scss'],
    imports: [ActionAgeingActionableIssueCountComponent, ActionAgeingActionableIssueSummaryComponent, ActionAgeingActionableIssueTrendChartComponent, ActionAgeingActionableIssueBarChartComponent]
})
export class ProjectActionAgeingHomeComponent implements OnInit {
  mainDiscription: string = 'Monitor open actionable issues, see the breakdown of items within and outside the target TAT, and view counts by hierarchy.'
  destroyRef = inject(DestroyRef);
  trendChartComponentId: string = "ageing-trend-chart-" + this.getTimeStamp()
  barChartComponentId: string = "ageing-bar-chart-" + this.getTimeStamp()
  summaryTableComponentId: string = "action-ageing-summary-table"
  loadingOverallData: boolean = false;
  totalResponses: string | null = null;
  totalActionableResponses: string | null = null;
  data: any = []
  queryAndData: any = {};
  raterDetails: any = {}
  brandDetails: any = {};
  universalFilter: any = {};
  selectedHierarchy: any = {}
  groupAliasKey: any = '';
  overallData: any = {
    elementId: this.summaryTableComponentId,
    data: []
  }
  distType: string = "percentage";
  filterObj: any = {}
  projectId: string = '';
  fromDate: string = '';
  toDate: string = '';
  date_filter_type: number = 1;
  date_filter_field: string = "created_date";

  constructor(
    public _actionService: ActionService,
    private route: ActivatedRoute,
    private _helpers: HelpersService
  ) { }

  ngOnInit() {
    this._helpers.appState.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((state: any) => {
      if (state && !state.pending) {
        this.projectId = state.brandDetails['_id'];
        this.brandDetails = state.brandDetails
        this.universalFilter = state.universalFilter ? state.universalFilter : {};
        this.fromDate = state.datePicker['startDate'];
        this.toDate = state.datePicker['endDate'];
        this.selectedHierarchy = state.hierarchyStack;
        let field_id: string = '';
        if (this.selectedHierarchy && this.selectedHierarchy.length) {
          field_id = this.selectedHierarchy[this.selectedHierarchy.length -1].field_id;
        }
        this.groupAliasKey = this._actionService.getGroupAliasKey(field_id, state.brandDetails.hierarchy_list_alias)
        this.date_filter_type = state.datePicker['dateFilterType'];
        this.date_filter_field = (state.datePicker['isRequestDate']) ? "feedback_request_date" : "created_date";
        this.getOverallData();
      }
    })
  }

  ngOnChange() {
    this.getOverallData();
  }

  getTimeStamp() {
    return new Date().getTime()
  }

  onDrilldownChange(data?: any) {
    this.filterObj = data;
  }

  getRequestParams() {
    this.loadingOverallData = true;
    this.data = [];
    var params = this._actionService.getInitialQueryParameters();
    if (Helpers.hierarchyStack && Helpers.hierarchyStack.length) {
      params.hierarchy_stack = Helpers.hierarchyStack;
    }
    params.from = this.fromDate;
    params.to = this.toDate;
    params.brand_id = this.projectId,
    params.group_key_alias = this.groupAliasKey
    params.view_type = 'overall';
    params.field_id = 'overall';
    params.field_type = 'overall';
    params.question_aggs = true;
    params.is_custom_date_range_selected = true;
    params.universal_filter = this.universalFilter;
    params.actionable_filter = _.get(this.brandDetails, "action_management_configuration.actionables", {});
    params.action_type = "ageing";
    params.age_type = _.get(this.brandDetails, "action_management_configuration.ageing_config.type", 1);
    params.date_field = this.date_filter_field;
    params.turnaround = _.get(this.brandDetails, "action_management_configuration.ageing_config.turnaround_time", 0);
    this.queryAndData = {};
    this.queryAndData.query = params;
    return params;
  }

  getOverallData() {
    this.totalResponses = null;
    this.totalActionableResponses = null;
    const params = this.getRequestParams();
    this.overallData.query = params;
    this._actionService.getComparisonData(params).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((responseObject) => {

      if (responseObject && responseObject.code == 0 && responseObject.data.feed_details) {
        if (responseObject.data.age && !_.isEmpty(responseObject.data.age)) {
          responseObject.data.feed_details["age"] = _.get(responseObject.data, "age.age", 0);
          responseObject.data.feed_details['within_tat'] = _.get(responseObject.data, "age.within_tat", 0);
          responseObject.data.feed_details['outside_tat'] = _.get(responseObject.data, "age.outside_tat", 0);
        }

        const doc_count = _.get(responseObject, 'data.feed_details.current.doc_count', 0);
        const actionables = _.get(responseObject, 'data.feed_details.current.actionables', 0);
        this.totalResponses = new Number(doc_count).toLocaleString('en-IN')
        this.totalActionableResponses = new Number(actionables).toLocaleString('en-IN')

        var response = this.processOverallReponse(responseObject.data.feed_details);
        response = _.assign(response, _.get(responseObject.data, "age", {}));
        response.age = Math.round(response.age)
        response.actionables = _.get(responseObject, 'data.feed_details.current.actionables', 0);
        if (this.selectedHierarchy && this.selectedHierarchy.length) {
          response.name = this.selectedHierarchy[0].group_key[0];
        } else {
          response.name = _.get(this.brandDetails, 'name', '');
        }

        response.resolved = _.get(response, 'resolved', 0);
        response.unresolved = _.get(response, 'unresolved', 0);
        let totalCount:any = 0;
        totalCount = response.within_tat + response.outside_tat
        response.percent = {
          doc_count: this.getPercentage(totalCount, totalCount),
          within_tat: this.getPercentage(response.within_tat, totalCount),
          outside_tat: this.getPercentage(response.outside_tat, totalCount)
        }
        response.within_tat_with_percentage = response.within_tat + '(' + response.percent.within_tat + '%)'
        response.outside_tat_with_percentage = response.outside_tat + '(' + response.percent.outside_tat + '%)'
        this.overallData.data = _.map([response], (obj)=>{
          return obj;
        });
        this.overallData.elementId = this.summaryTableComponentId,
        this.loadingOverallData = false;

      } else {
        this.loadingOverallData = false;
        this.totalResponses = '0';
        this.totalActionableResponses = '0';
      }
    }, () => {
      // Handle error case
      this.totalResponses = '0';
      this.totalActionableResponses = '0';
    })
  }

  getPercentage(count: number, total: number) {
    let percentage: any = '';
    percentage = (((count / total) * 100)).toFixed(1);
    if (percentage >= 0) {
      return percentage;
    } else {
      return '0.0'
    }
  }

  processOverallReponse(response: any) {
    var distributions = [];
    if (this.raterDetails && this.raterDetails.distributions) {
      distributions = this.raterDetails.distributions;
    }
    if (response.current) {
      var currentData = response.current;
      var previousData = {};
      var processedResponse: any = {};
      processedResponse = response;
      var resolvedUnresolvedData = this.getDistribution(processedResponse, 100, currentData.status_distribution);

      var ageDistribution = this.getAgeDistribution(response.within_tat, response.outside_tat, 100);

      processedResponse.age = Math.round(_.get(response, "age", 0));

      var tatDistribution = this.getAgeDistribution(response.within_tat, response.outside_tat, 100);

      processedResponse.tat_distribution = tatDistribution.distribution;
      processedResponse.age_distribution = ageDistribution.distribution;
      processedResponse.status_distribution = resolvedUnresolvedData.distribution;
      processedResponse.resolved = resolvedUnresolvedData.resolved;
      processedResponse.unresolved = resolvedUnresolvedData.unresolved;
      return processedResponse;

    } else {
      return {};
    }
    return response;
  }
  getAgeDistribution(withInTat: any, outSideTat: any, maxValue: any) {
    var distribution = {
      "value": [],
      "raterType": "distribution",
      "options": {
        "no_of_distribution": 1,
        "distributionType": this.distType,
        "maxValue": maxValue,
        "displayValue": false,
        "totalResponse": withInTat + outSideTat ? withInTat + outSideTat : null,
        "showPercentage": true,
        // "isLinearGradientEnabled":true
      }
    }

    var statusdDistribution: any = [];
    var selectedTab = 'ageing'
    var distributionLabels = _.get(this.brandDetails, "action_management_configuration.widget_settings.action_summary", {});
    distributionLabels = {
      green_bucket: _.get(distributionLabels, selectedTab + ".green_bucket", {}),
      red_bucket: _.get(distributionLabels, selectedTab + ".red_bucket", {})
    }
    if (selectedTab == "ageing") {
      statusdDistribution.push({
        'label': distributionLabels.green_bucket.label || 'Unsolved Within Target TAT',
        'rated': withInTat,
        'color': distributionLabels.green_bucket.color || '#10a754',
        'value': distributionLabels.green_bucket.label || 'Unsolved Within Target TAT'
      });
      statusdDistribution.push({
        'label': distributionLabels.red_bucket.label || 'Unsolved Outside Of Target TAT',
        'rated': outSideTat,
        'color': distributionLabels.red_bucket.color || '#69a8fc',
        'value': distributionLabels.red_bucket.label || 'Unsolved Outside Of Target TAT'
      })
    } else if (selectedTab == "tat") {
      statusdDistribution.push({
        'label': distributionLabels.green_bucket.label || 'Solved Within Target TAT',
        'rated': withInTat,
        'color': distributionLabels.green_bucket.color || '#10a754',
        'value': distributionLabels.green_bucket.label || 'Solved Within Target TAT'
      });
      statusdDistribution.push({
        'label': distributionLabels.red_bucket.label || 'Solved Outside Of Target TAT',
        'rated': outSideTat,
        'color': distributionLabels.red_bucket.color || '#fab416',
        'value': distributionLabels.red_bucket.label || 'Solved Outside Of Target TAT'
      })
    }

    distribution.value = statusdDistribution
    return { "distribution": distribution };
  }
  getDistribution(summary: any, maxValue: any, distributions: any) {
    var resolved: number = 0;
    var unresolved: number = 0;
    distributions = JSON.parse(JSON.stringify(distributions));
    var distribution = {
      "value": [],
      "raterType": "distribution",
      "options": {
        "no_of_distribution": 1,
        "distributionType": this.distType,
        "maxValue": maxValue,
        "displayValue": false,
        "totalResponse": (summary && summary.actionables) ? summary.actionables : null,
        "showPercentage": true,
        // "isLinearGradientEnabled":true
      }
    }
    if (distributions && _.keys(distributions).length) {
      var distributionLabels = _.get(this.brandDetails, "action_management_configuration.widget_settings.action_summary.count", {})
      distributionLabels = {
        "green_bucket": _.get(distributionLabels, "red_bucket", {}),
        "red_bucket": _.get(distributionLabels, "green_bucket", {})
      }
      var statusdDistribution: any = [];

      var closedStatusList = this.getClosedStatusValueFromBrand(this.brandDetails)
      _.each(distributions, function (value: any, key: string) {
        if (closedStatusList.indexOf(key) >= 0) {
          resolved = resolved + value;
        } else {
          unresolved = unresolved + value;
        }
      });
      //changing labels to solved unsolved as enhancement in stats v2
      statusdDistribution.push({ 'label': distributionLabels.red_bucket.label || 'Unsolved', 'rated': unresolved, 'color': distributionLabels.red_bucket.color || '#ed2424', 'value': distributionLabels.red_bucket.label || 'Unresolved' });
      statusdDistribution.push({ 'label': distributionLabels.green_bucket.label || 'Solved', 'rated': resolved, 'color': distributionLabels.green_bucket.color || '#10a754', 'value': distributionLabels.green_bucket.label || 'Resolved' })

      distribution.value = statusdDistribution
    }
    return { "distribution": distribution, "resolved": resolved, "unresolved": unresolved };
  }
  getClosedStatusValueFromBrand(brand_details: any) {
    //get value of closed status from brand
    var status_closed_uuid = "c71a8524-7fc4-49d3-894a-2555dcc6ed07";
    if (_.get(brand_details, 'lw_status_list_map.LW_CLOSED')) {
      status_closed_uuid = brand_details.lw_status_list_map.LW_CLOSED
    } else {
      var maped_status = {}
      if (_.get(brand_details, "status_list")) {
        var status_list = brand_details.status_list
        for (var index in status_list) {
          maped_status[status_list[index].name] = status_list[index]
        }
      }
      if (_.get(maped_status, "Closed.uuid")) {
        status_closed_uuid = maped_status['Closed']['uuid']
      }
    }
    return status_closed_uuid;
  }

}
